import axios from "axios";
import Cookies from "js-cookie";

const baseURL = process.env.REACT_APP_BASE_BACKEND_API_URL;

/**
 * Call Blufield AI Agent chat API.
 * Normalizes response to always return { message, data, intentUsed }.
 *
 * @param {Object} params
 * @param {string} params.message - User's input.
 * @param {string} params.sessionId - Stable session id per conversation.
 */
export const agentChat = async ({ message, sessionId }) => {
  const token = Cookies.get("accessToken");

  const response = await axios.post(
    `${baseURL}api/v1/agent/chat`,
    {
      message,
      sessionId,
    },
    {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  );

  // API spec says response body is:
  // { message, data?, intentUsed }
  // but backend may also wrap in header/body.
  const raw = response.data?.body?.value || response.data || {};

  return {
    message: raw.message || "",
    data: Array.isArray(raw.data) ? raw.data : [],
    intentUsed: raw.intentUsed || "",
  };
};

